import { useEffect, useState } from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import general from "../../general";
import { useInterval } from "ahooks";
import Dialog from "../../lib/Dialog";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";

// 绑定手机
export default (props) => {
  useEffect(() => {
    props.setOperate(
      <div onClick={() => general.goBack(true)} className="account-phone">
        跳过
      </div>
    );
  }, []);

  const [data, setData] = useState({
    mobile: "",
    code: "",
  });

  const [coding, setCoding] = useState(false);
  const [codeTime, setCodeTime] = useState(0);
  useInterval(() => {
    if (codeTime) {
      setCodeTime(codeTime - 1);
    }
  }, 1000);

  const encodeAndHash = (value) => {
    // Base64 编码
    const base64Encoded = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(value)
    );

    // MD5 加密
    const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);

    return md5Hash;
  };

  const code = () => {
    if (!data.mobile) {
      Dialog.error("请输入手机号");
      return;
    }
    if (coding || codeTime) {
      return;
    }
    setCoding(true);
    Dialog.loading();

    let str = `02${data.mobile}${dayjs().unix().toString()}`;

    general.axios
      .post("/v3/base/tool/getVerifyCode", {
        mobile: data.mobile,
        code: "code",
        type: "02",
        time: dayjs().unix().toString(),
        sign: encodeAndHash(str),
      })
      .finally(() => {
        setCoding(false);
        Dialog.close();
      })
      .then((response) => {
        let result = response.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          setCodeTime(60);
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  const [saving, setSaving] = useState(false);
  const save = () => {
    if (saving) {
      return;
    }
    if (!data.mobile) {
      Dialog.error("请输入手机号");
      return;
    }
    if (!data.code) {
      Dialog.error("请输入验证码");
      return;
    }
    setSaving(true);
    Dialog.loading();
    general.axios
      .post("/v3/user/user/bindPhone", data)
      .finally(() => {
        setSaving(false);
        Dialog.close();
      })
      .then((response) => {
        let { status } = response.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          Dialog.success("保存成功", () => general.goBack(true));
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  return (
    <div className="account-phonelogin account-phone">
      <div className="phonelogin-body body">
        <div className="input">
          <div className="input-content">
            <div className="input-content-left">
              <span className="input-content-left-prefix">手机号</span>

              <input
                type="number"
                value={data.mobile}
                placeholder="请输入手机号"
                autoComplete="off"
                onChange={(e) => setData({ ...data, mobile: e.target.value })}
              />
            </div>

            {data.mobile ? (
              <CloseCircleOutlined
                className="clear"
                style={{ marginRight: 0 }}
                onClick={() => setData({ ...data, mobile: "" })}
              />
            ) : null}
          </div>
        </div>

        <div className="input code">
          <div className="input-content">
            <div className="input-content-left">
              <span className="input-content-left-prefix">验证码</span>

              <input
                type="tel"
                value={data.code}
                placeholder="请输入验证码"
                autoComplete="off"
                onChange={(e) => setData({ ...data, code: e.target.value })}
              />

              {data.code ? (
                <CloseCircleOutlined
                  className="clear"
                  onClick={() => setData({ ...data, code: "" })}
                />
              ) : null}
            </div>

            <div
              className={"code-btn " + (coding || codeTime ? "disable" : "")}
              onClick={code}
            >
              {coding ? (
                "发送中"
              ) : codeTime ? (
                <>
                  <p className="code-time">{codeTime}</p>秒后重试
                </>
              ) : (
                "获取验证码"
              )}
            </div>
          </div>
        </div>

        <div
          style={{ marginTop: "48px" }}
          className={"btn " + (saving ? "disable" : "")}
          onClick={save}
        >
          保存
        </div>
      </div>
    </div>
  );
};
